import React, { useContext } from 'react';
import AppContext from '../AppContext/AppContext';
import { Link } from 'react-router-dom';
import UserPopover from '../UserPopover/UserPopover';
import { Button } from '@mui/material';

export default function UserTools(props: any) {
  const { state, dispatch } = useContext(AppContext);
  const license = state.license;

  return (
    <nav className="header__nav" aria-label="Primary">
      { (license?.sitesRemaining === 0 || license?.productId !== 2273 ) && (
        <a href={'https://softlite.io/pricing/clonewebx/?email=' + state.user.email + '&first_name=' + state.user.first_name + '&last_name=' + state.user.last_name} target="_blank" rel="noreferrer">
          <Button variant="contained" className="header__button header__upgrade">Upgrade</Button>
        </a>
      )}
      <Link to="/find-inspiration/" className="header__nav-link header__nav-link--sparkle hidden-mobile">
        Find website inspiration
      </Link>
      <a href="https://softlite.io/uibrainx/" target="_blank" rel="noreferrer" className="header__nav-link hidden-mobile">
        UIBrainX
      </a>
      <a href="https://softlite.io/figwebx/" target="_blank" rel="noreferrer" className="header__nav-link hidden-mobile">
        FigwebX
      </a>
      <a href="https://softlite.io/litemove/" target="_blank" rel="noreferrer" className="header__nav-link hidden-mobile">
        Litemove
      </a>
      <a href="https://softlite.io/docs/clonewebx/" target="_blank" rel="noreferrer" className="header__nav-link">
        Documents
      </a>
      <UserPopover />
    </nav>
  );
}
